<template>
    <div v-bind:class="{'d-none': !showItem}" class="row" style="margin-top: 10px;">
        <div class="col-12">
            <div class="form-group" style="width: 100%;">
                <label :for="item.key">{{ item.label }}</label>
                <input :id="item.key" :name="item.key" :placeholder="item.label" type="text" v-model="itemValue" class="form-control" autocomplete="off">
            </div>
        </div>
    </div>
</template>
<script>
    import EventBus from '../../../../EventBus'

    export default {
        props: [
            'item',
            'restaurant'
        ],

        data () {
            return {
                itemValue: null,
                showItem: true,
            }
        },

        created() {
            var _this = this;
            EventBus.$on('serviceTypeFormValueUpdated', (data) => {
                if (data.key == 'is_programmed') {
                    if (data.value == 'Adesso' || data.value == 'adesso') {
                        _this.showItem = false;
                    } else {
                        _this.showItem = true;
                    }
                }
            });
        },

        mounted() {
            this.createPicker();
        },

        methods: {
            createPicker() {
                var _this = this;
                let serviceTypeConfig = this.restaurant.service_type_config;
                const picker = datepicker('#' + this.item.key, {
                    customDays: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
                    customMonths: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
                    startDate: new Date(),
                    dateSelected: false,
                    startDay: 1,
                    disabler: date => {
                        let serviceTypeDates = _.map(_.toArray(serviceTypeConfig.service_type_date), _.toNumber);
                        return ((date < moment().startOf('day')) ||  (_.indexOf(serviceTypeDates, date.getDay()) == -1));
                    },
                    formatter: (input, date, instance) => {
                        input.value = moment(date).format('DD/MM/YYYY');
                    },
                    onSelect: instance => {
                        EventBus.$emit('serviceTypeFormValueUpdated', {
                            key: _this.item.key,
                            value: moment(instance.dateSelected).format('DD/MM/YYYY')
                        });
                    },
                });
            }
        }
    }
</script>
